import { useQuery } from '@tanstack/react-query'
import { LobsterMasterApi } from '@ulysses-inc/harami_api_client'
import { baseClient } from 'src/state/middleware/saga/baseClient'
import { labelMasterQueryKeys } from './queryKeys'

export const useQueryLabelMaster = (labelMasterId: string) => {
  return useQuery({
    queryKey: labelMasterQueryKeys.labelMasters.detail(labelMasterId),
    queryFn: () =>
      baseClient
        .getApi(LobsterMasterApi)
        .getInternalLabelMaster({ id: labelMasterId }),
    retry: 0,
    gcTime: 0,
    throwOnError: true,
  })
}
